"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OffersTable = OffersTable;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const dayjs_1 = __importDefault(require("dayjs"));
const slug_offer_1 = __importDefault(require("shared/slug-offer"));
const antd_1 = require("antd");
const index_1 = require("@src/app/index");
const react_intl_1 = require("react-intl");
const Api = __importStar(require("api"));
const elements_1 = require("components/elements");
const icons_1 = require("@ant-design/icons");
const big_js_1 = __importDefault(require("big.js"));
const styled_components_1 = require("styled-components");
const react_query_1 = require("react-query");
const queries_1 = require("@src/types/queries");
const admin_context_1 = require("../../admin-context");
const OffersTable_style_1 = require("./OffersTable.style");
const OffersTabs_1 = require("./OffersTabs");
const offer_promotion_context_1 = require("./offer-promotion-context");
function MenuItem(props) {
    return ((0, jsx_runtime_1.jsxs)("span", { className: "flex-row justify-start align-center", children: [(0, jsx_runtime_1.jsx)(props.icon, { className: "m-r-s" }), props.label] }));
}
function TitleInput(props) {
    const [internalOfferTitle, setInternalOfferTitle] = react_1.default.useState(props.title);
    const [lastSavedTitle, setLastSavedTitle] = react_1.default.useState(props.title);
    const [isSaveNecessary, setIsSaveNecessary] = react_1.default.useState(false);
    const intl = (0, react_intl_1.useIntl)();
    const queryClient = (0, react_query_1.useQueryClient)();
    // Sync internal state with props when they change
    react_1.default.useEffect(() => {
        setInternalOfferTitle(props.title);
        setLastSavedTitle(props.title);
    }, [props.title]);
    const saveOffer = async () => {
        try {
            if (!isSaveNecessary) {
                return;
            }
            const trimmedValue = internalOfferTitle ? internalOfferTitle.trim() : (lastSavedTitle === null || lastSavedTitle === void 0 ? void 0 : lastSavedTitle.trim()) || '';
            setInternalOfferTitle(trimmedValue);
            setLastSavedTitle(trimmedValue);
            await Api.Admin.patchOfferTitle(props.id, trimmedValue);
            queryClient.invalidateQueries(queries_1.Queries.getMyOffers);
            setIsSaveNecessary(false);
            antd_1.notification.success({
                message: intl.formatMessage({
                    id: 'admin.offers.offers_table.successfuly_saved',
                }),
            });
        }
        catch (err) {
            console.error(err);
        }
    };
    const setTitle = (e) => {
        const target = e.target;
        setInternalOfferTitle(target.value);
        setIsSaveNecessary(true);
    };
    return (0, jsx_runtime_1.jsx)(OffersTable_style_1.OfferTitleInput, { onChange: setTitle, value: internalOfferTitle !== null && internalOfferTitle !== void 0 ? internalOfferTitle : '', onBlur: saveOffer, maxLength: 100 });
}
function OffersTable({ offers, type, openArchiveModal, }) {
    const [internalOffers, setInternalOffers] = react_1.default.useState([]);
    const intl = (0, react_intl_1.useIntl)();
    const theme = (0, styled_components_1.useTheme)();
    const { myOffers } = (0, admin_context_1.useAdminContextValue)();
    const { setShowPromotionModal, setPromotingOffer } = (0, offer_promotion_context_1.useOfferPromotionContextValue)();
    react_1.default.useEffect(() => {
        // add key for react indexing
        setInternalOffers(offers.map(o => ({ ...o, key: `offer-row-${o.id}` })));
    }, [offers]);
    const calculateConversion = (applicationCount, viewsCount) => {
        if (!applicationCount || !viewsCount) {
            return 0;
        }
        const divisionResult = new big_js_1.default(applicationCount).div(viewsCount).times(100);
        return divisionResult.toFixed(2);
    };
    const archiveDraft = react_1.default.useCallback(async (id) => {
        try {
            await Api.Offer.archiveOffer(id);
            // await onArchive()
            antd_1.notification.success({
                message: intl.formatMessage({
                    id: 'admin.offers.offers_table.successfuly_archived',
                }),
                description: '',
            });
        }
        catch (err) {
            console.error(err);
        }
    }, []);
    const getTableColumnConfig = () => {
        const isArchived = type === OffersTabs_1.EOffersType.notActive;
        const isActive = type === OffersTabs_1.EOffersType.active;
        const isDraft = type === OffersTabs_1.EOffersType.drafts;
        const titleCol = {
            title: intl.formatMessage({
                id: 'general.position',
            }),
            dataIndex: 'title',
            key: 'title',
            align: 'left',
            render: (data, offer) => {
                const { isPromoted } = offer;
                return ((0, jsx_runtime_1.jsxs)("div", { className: "flex-row align-center", children: [isArchived && (0, jsx_runtime_1.jsx)("span", { style: { maxWidth: '350px' }, children: data }), isActive && (0, jsx_runtime_1.jsx)(TitleInput, { id: offer.id, title: offer.title }), isDraft && (0, jsx_runtime_1.jsxs)(OffersTable_style_1.OfferTitle, { children: [offer.title || intl.formatMessage({ id: 'admin.offers.draft' }), " ", (0, jsx_runtime_1.jsxs)("span", { children: ["(", (0, dayjs_1.default)(offer.createdAt).format('DD.MM.YYYY, HH:mm'), ")"] })] }, offer.id), isPromoted && isActive && ((0, jsx_runtime_1.jsx)(antd_1.Tooltip, { placement: "top", title: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.offers.promoted_offer.until", values: { date: (0, dayjs_1.default)(offer.promotedUntil).format('D. MMM YYYY') } }), children: (0, jsx_runtime_1.jsxs)(OffersTable_style_1.PromotedTag, { color: theme.color.premium, children: [(0, jsx_runtime_1.jsx)(icons_1.CrownOutlined, { className: "m-r-s" }), intl.formatMessage({ id: 'admin.offers.promoted_offer' })] }) }))] }));
            },
        };
        const applicationCountCol = {
            title: intl.formatMessage({
                id: 'general.candidates',
            }),
            dataIndex: 'applicationCount',
            key: 'applicationCount',
            width: 120,
            align: 'center',
            render: (data, offer) => {
                return ((0, jsx_runtime_1.jsx)(OffersTable_style_1.ApplicantsCell, { to: `/admin/vyberovy-proces/${offer.id}`, children: (0, jsx_runtime_1.jsxs)(OffersTable_style_1.AnalyticsDataCell, { children: [(0, jsx_runtime_1.jsx)(icons_1.TeamOutlined, {}), data] }) }));
            },
        };
        const viewsCountCol = {
            title: intl.formatMessage({
                id: 'general.views',
            }),
            dataIndex: 'viewsCount',
            key: 'viewsCount',
            width: 130,
            align: 'center',
            render: (data, { viewsCount, applicationCount }) => {
                const conversionRate = calculateConversion(applicationCount, viewsCount);
                return ((0, jsx_runtime_1.jsx)(antd_1.Tooltip, { placement: "top", title: (0, jsx_runtime_1.jsxs)("div", { className: "flex-col align-center", children: [(0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.offers.conversion_rate" }) }), (0, jsx_runtime_1.jsxs)("div", { children: [conversionRate, "%"] })] }), children: (0, jsx_runtime_1.jsxs)(OffersTable_style_1.AnalyticsDataCell, { children: [(0, jsx_runtime_1.jsx)(icons_1.LineChartOutlined, {}), data] }) }));
            },
        };
        const actionButtonsCol = {
            title: '',
            width: 100,
            align: 'center',
            render: (data) => {
                const offerSlug = new slug_offer_1.default({ suffix: data.id, text: data.title });
                return ((0, jsx_runtime_1.jsxs)("span", { children: [isActive && ((0, jsx_runtime_1.jsx)(elements_1.ComboButton, { onClick: () => index_1.history.pushLocalized(`/admin/uprava-ponuky/${offerSlug.result}`), menu: [
                                {
                                    label: ((0, jsx_runtime_1.jsxs)("span", { className: "flex-row justify-start align-center", children: [(0, jsx_runtime_1.jsx)(icons_1.CrownOutlined, { className: "m-r-s" }), intl.formatMessage({
                                                id: 'general.promote',
                                            })] })),
                                    onClick: () => {
                                        var _a;
                                        setShowPromotionModal(true);
                                        setPromotingOffer((_a = myOffers === null || myOffers === void 0 ? void 0 : myOffers.active) === null || _a === void 0 ? void 0 : _a.find(({ id }) => id === data.id));
                                    },
                                    disabled: data.isPromoted,
                                },
                                {
                                    label: ((0, jsx_runtime_1.jsx)(MenuItem, { label: intl.formatMessage({
                                            id: 'general.duplicate',
                                        }), icon: icons_1.CopyOutlined })),
                                    onClick: () => index_1.history.pushLocalized(`/admin/uprava-ponuky/${offerSlug.result}?duplicate=true`),
                                },
                                {
                                    label: ((0, jsx_runtime_1.jsx)(MenuItem, { label: intl.formatMessage({
                                            id: 'general.insight',
                                        }), icon: icons_1.EyeOutlined })),
                                    onClick: () => window.open(`/ponuka/${offerSlug.result}`, '_blank'),
                                },
                                {
                                    label: ((0, jsx_runtime_1.jsx)(MenuItem, { label: intl.formatMessage({
                                            id: 'general.archive',
                                        }), icon: icons_1.DeleteOutlined })),
                                    onClick: () => {
                                        openArchiveModal(data.id);
                                    },
                                },
                            ], children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "general.edit" }) })), isDraft && ((0, jsx_runtime_1.jsx)(elements_1.ComboButton, { type: "default", onClick: () => index_1.history.pushLocalized(`/admin/pridat-ponuku?slug=${offerSlug.result}`), menu: [
                                {
                                    label: ((0, jsx_runtime_1.jsx)(MenuItem, { label: intl.formatMessage({
                                            id: 'general.archive',
                                        }), icon: icons_1.DeleteOutlined })),
                                    onClick: () => {
                                        archiveDraft(data.id);
                                    },
                                },
                            ], children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "general.edit" }) })), isArchived && ((0, jsx_runtime_1.jsx)(elements_1.ComboButton, { type: "default", onClick: () => index_1.history.pushLocalized(`/admin/uprava-ponuky/${offerSlug.result}?duplicate=true`), menu: [
                                {
                                    label: ((0, jsx_runtime_1.jsx)(MenuItem, { label: intl.formatMessage({
                                            id: 'general.insight',
                                        }), icon: icons_1.EyeOutlined })),
                                    onClick: () => window.open(`/ponuka/${offerSlug.result}`, '_blank'),
                                },
                            ], children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "general.duplicate" }) }))] }));
            },
        };
        if (isDraft) {
            return [titleCol, actionButtonsCol];
        }
        return [titleCol, applicationCountCol, viewsCountCol, actionButtonsCol];
    };
    return ((0, jsx_runtime_1.jsx)(elements_1.Table, { bordered: true, pagination: false, scroll: { x: 'max-content' }, rowKey: "id", dataSource: internalOffers, columns: getTableColumnConfig() }));
}
